import { useSyncExternalStore } from 'react';
import { projectStore } from '../lib/projectStore';

export function useActiveProject() {
  const activeProjectId = useSyncExternalStore(projectStore.subscribe, projectStore.getProjectId);
  return { activeProjectId, setActiveProjectId: projectStore.setProjectId };
}
